(() => {
  const init = () => {
    const root = document.querySelector('[data-cl-welcome]');
    if (!root || root.dataset.ready === 'true' || /\/(cart|checkouts)(\/|$)/.test(location.pathname)) return;
    root.dataset.ready = 'true';
    const overlay = root.querySelector('[data-cl-welcome-overlay]');
    const dialog = root.querySelector('[data-cl-welcome-dialog]');
    const teaser = root.querySelector('[data-cl-welcome-teaser]');
    const closeButton = root.querySelector('[data-cl-welcome-close]');
    const key = 'clEarlyBird2026Dismissed';
    let focusBefore = null;
    const storageGet = () => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
    const storageSet = () => { try { sessionStorage.setItem(key, '1'); } catch (_) {} };
    const targets = () => Array.from(dialog.querySelectorAll('button, a[href], input, [tabindex]')).filter(el => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length);
    const open = () => {
      if (!overlay.hidden || document.querySelector('cart-drawer.active, .menu-drawer-container[open]')) return;
      focusBefore = document.activeElement;
      overlay.hidden = false;
      teaser.hidden = true;
      document.body.classList.add('cl-welcome-open');
      requestAnimationFrame(() => (targets()[0] || dialog).focus());
    };
    const close = () => {
      overlay.hidden = true;
      teaser.hidden = false;
      document.body.classList.remove('cl-welcome-open');
      storageSet();
      focusBefore?.focus?.();
    };
    teaser.hidden = false;
    teaser.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', event => { if (event.target === overlay) close(); });
    root.querySelector('.cl-welcome__continue').addEventListener('click', close);
    document.addEventListener('keydown', event => {
      if (overlay.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const list = targets();
      if (!list.length) return;
      if (event.shiftKey && document.activeElement === list[0]) { event.preventDefault(); list.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === list.at(-1)) { event.preventDefault(); list[0].focus(); }
    });
    if (!storageGet() && !window.Shopify?.designMode && window.matchMedia("(min-width: 750px)").matches) setTimeout(open, 12000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();

